import React, { Component } from 'react';
import Form from '../../components/application/forms/FullScreenForm';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { userEmailSelector } from '../../selectors/authentication';
import { CKP_COLOR_GREEN } from '../../constants/styling/styles';
import { Link } from 'react-router-dom';
import { LOGIN_PATH } from '../../constants/routes';

class ForgotPasswordMail extends Component {
    render() {
        return (
            <Form
                header={"You've Got Mail"}
                body={
                    <div className="ckp-forms-info">
                        <i className="fa fa-envelope ckp-forms-info-icon fa-3x" style={{ color: CKP_COLOR_GREEN }} />
                        <p className="ckp-forms-info-text">
                            <span>If an account exists for</span> <span className="u-bold">{this.props.email},</span>
                            <span>we have sent an email with instructions.</span>
                        </p>
                        <Link className="ckp-buttons-link" to={LOGIN_PATH}>
                            Back to login
                        </Link>
                    </div>
                }
                footer={
                    <div className="ckp-forms-footer-sticky">
                        Need help? Contact us at{' '}
                        <a href="mailto:techsupport@clearem.tv" className="u-bold">
                            techsupport@clearem.tv
                        </a>
                    </div>
                }
            />
        );
    }
}

const mapStateToProps = state => ({
    email: userEmailSelector(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordMail);
